import { FC } from "react";
import { Empty } from "antd";
import { DocumentCard } from "../../../design-system/components/DocumentList/DocumentCard";
import { Project, ProjectAnalysis } from "../../../types/ProjectTypes";
import { getAttachmentDownloadUrl } from "../../../common/api/ProjectClient";
import styles from "./AttachmentsList.module.less";

interface AttachmentsListProps {
    project: Project;
    analysis: ProjectAnalysis;
}

export const AttachmentsList: FC<AttachmentsListProps> = ({ project, analysis }) => {
    const attachments = analysis.attachments ?? [];

    if (attachments.length === 0) {
        return <Empty description="No attachments" />;
    }

    const uploadedAt =
        analysis.completedDate ?? analysis.submittedDate ?? analysis.recordCreationDate;

    return (
        <div className={styles.list}>
            {attachments.map((doc) => (
                <a
                    key={doc.id}
                    href={getAttachmentDownloadUrl(project.id, analysis.version, doc.id)}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={styles.item}
                >
                    <DocumentCard
                        name={doc.name}
                        uploadedBy="InfinityLoop"
                        uploadedAt={uploadedAt}
                    />
                </a>
            ))}
        </div>
    );
};
